import React from "react";
import removeImg from "assets/svgs/close.svg";
import { v4 } from "uuid";
import { Col, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import ImageUpdateEn from "./ImageUpdateEn";
import ImageUpdateAr from "./ImageUpdateAr";

const SlidersArray = ({ sliders, setSliders }) => {
  const removeSlider = (sliderId) => {
    const newSliders = sliders?.filter(
      (slider, index) => slider.id !== sliderId
    );
    setSliders(() => newSliders);
  };

  const addSlider = () => {
    setSliders(() => [...(sliders || []), { id: v4() }]);
  };
  return (
    <div className="form-group branches sliders">
      <Row style={{ rowGap: "10px" }}>
        <h5>
          <FormattedMessage id={"intro"} />
        </h5>

        {sliders?.map((slider, index) => {
          return (
            <Col xl={12} xs={12} key={slider.id} className="">
              <div className="add-multi-component">
                <Row>
                  <button
                    type="button"
                    onClick={() => removeSlider(slider.id)}
                    className="removeImg"
                  >
                    <img src={removeImg} alt="" />
                  </button>
                  {/* name */}
                  <Col lg={6} className="text-center">
                    <ImageUpdateAr
                      title="imageAr"
                      index={index}
                      item={slider}
                      sliders={sliders}
                      setSliders={setSliders}
                    />
                  </Col>
                  <Col lg={6} className="text-center">
                    <ImageUpdateEn
                      title="imageEn"
                      index={index}
                      item={slider}
                      sliders={sliders}
                      setSliders={setSliders}
                    />
                  </Col>
                </Row>
              </div>
            </Col>
          );
        })}

        <Row>
          <Col lg={4} xs={12} className="text-left">
            <button
              type="button"
              className="btn btn-green add_new_section__"
              onClick={() => {
                addSlider();
              }}
            >
              <FormattedMessage id={"addIntro"} />
            </button>
          </Col>
        </Row>
      </Row>
    </div>
  );
};

export default SlidersArray;
